// // src/components/SearchResultsPage.jsx

// import { useEffect, useState, useCallback } from "react";
// import { useSearchParams } from "react-router-dom";
// import { searchProducts } from "../api/searchApi";
// import BackButton from "./BackButton";

// export default function SearchResultsPage() {
//   const [searchParams] = useSearchParams();
//   const query = searchParams.get("q");

//   const [results, setResults] = useState([]);
//   const [nextPageToken, setNextPageToken] = useState("");
//   const [totalSize, setTotalSize] = useState(0);
//   const [correctedQuery, setCorrectedQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // You Might Also Like
//   const [youMightLike, setYouMightLike] = useState([]);

//   // Load results with pagination support
//   const loadResults = useCallback(
//     async (token = "") => {
//       if (!query) return;

//       if (!token) setLoading(true);
//       setError("");

//       try {
//         const data = await searchProducts(query, 10, token);

//         const newRecords = data.records.map((p) => ({
//           id: p.article_id,
//           name: p.prod_name,
//           price: parseFloat(p.price).toFixed(2),
//           image: p.image_uri
//             ?.replace("storage.cloud.google.com", "storage.googleapis.com")
//             ?.trim(),
//           currency: p.currency,
//           description: p.detail_desc || "No description available.",
//         }));

//         setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
//         setNextPageToken(data.next_page_token || "");
//         setTotalSize(data.totalSize || 0);
//         setCorrectedQuery(data.correctedQuery || "");

//         if (!token && newRecords.length > 0) {
//           const shuffled = [...newRecords].sort(() => 0.5 - Math.random());
//           setYouMightLike(shuffled.slice(0, 5));
//         }
//       } catch (err) {
//         setError(err.message || "Search failed. Please try again.");
//         setResults([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [query]
//   );

//   // Load initial results
//   useEffect(() => {
//     if (query) {
//       loadResults("");
//     } else {
//       setLoading(false);
//     }
//   }, [query, loadResults]);

//   const loadMore = () => {
//     if (nextPageToken) {
//       loadResults(nextPageToken);
//     }
//   };

//   if (!query) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">No search query provided.</p>
//       </div>
//     );
//   }

//   if (loading && results.length === 0) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Searching...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10">
//       <BackButton />

//       <h1 className="text-3xl font-bold text-gray-900 mb-6">
//         Search Results for "{query}"
//       </h1>

//       {/* ✅ Show result count and "Did you mean?" */}
//       {!error && (
//         <>
//           <h2 className="text-xl text-gray-800 mb-4">
//             Showing {results.length} of {totalSize} results for "{query}"
//           </h2>

//           {/* Did you mean? */}
//           {correctedQuery && correctedQuery.trim() !== query.trim() && (
//             <div className="mt-2 p-3 bg-[#f0f9ff] border border-[#cdeefc] rounded-lg">
//               <p className="text-sm text-[#2c2452]">
//                 <span className="font-medium">Did you mean:</span>{" "}
//                 <button
//                   type="button"
//                   onClick={() =>
//                     (window.location.href = `?q=${encodeURIComponent(correctedQuery)}`)
//                   }
//                   className="text-[#3a3172] underline hover:text-[#2c2452] font-medium"
//                 >
//                   {correctedQuery}
//                 </button>
//                 ?
//               </p>
//             </div>
//           )}
//         </>
//       )}

//       {error && <p className="text-red-600 mb-6">{error}</p>}

//       {/* Results Grid */}
//       {results.length === 0 ? (
//         <p className="text-gray-600">No products found.</p>
//       ) : (
//         <>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//             {results.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={item.image || `https://picsum.photos/seed/${item.id}/400/600`}
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{item.name}</h3>
//                   <p className="text-[#3a3172] font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-3">{item.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {nextPageToken && (
//             <div className="text-center mt-8">
//               <button
//                 onClick={loadMore}
//                 className="px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800 font-medium"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </>
//       )}

//       {/* You Might Also Like */}
//       {youMightLike.length > 0 && (
//         <div className="mt-12">
//           <h2 className="text-2xl font-bold text-gray-900 mb-6">You Might Also Like</h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6">
//             {youMightLike.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/like-${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/like-${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{item.name}</h3>
//                   <p className="text-[#3a3172] font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-2">{item.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

//cahnges
//correct 
// src/components/SearchResultsPage.jsx
// import { useEffect, useState, useCallback } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom"; // ✅ Added useNavigate
// import { searchProducts, getProductDetails } from "../api/searchApi"; // ✅ Import new API function
// import BackButton from "./BackButton";

// export default function SearchResultsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate(); // ✅ Initialize navigate
//   const query = searchParams.get("q");

//   const [results, setResults] = useState([]);
//   const [nextPageToken, setNextPageToken] = useState("");
//   const [totalSize, setTotalSize] = useState(0);
//   const [correctedQuery, setCorrectedQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [attributionToken, setAttributionToken] = useState(""); // ✅ Store attribution token

//   // You Might Also Like
//   const [youMightLike, setYouMightLike] = useState([]);

//   // Load results with pagination support
//   const loadResults = useCallback(
//     async (token = "") => {
//       if (!query) return;

//       if (!token) setLoading(true);
//       setError("");

//       try {
//         const data = await searchProducts(query, 10, token);

//         const newRecords = data.records.map((p) => ({
//           id: p.article_id,
//           name: p.prod_name,
//           price: parseFloat(p.price).toFixed(2),
//           image: p.image_uri
//             ?.replace("storage.cloud.google.com", "storage.googleapis.com")
//             ?.trim(),
//           currency: p.currency,
//           description: p.detail_desc || "No description available.",
//         }));

//         setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
//         setNextPageToken(data.next_page_token || "");
//         setTotalSize(data.totalSize || 0);
//         setCorrectedQuery(data.correctedQuery || "");
//         setAttributionToken(data.attributionToken || ""); // ✅ Store the attribution token

//         if (!token && newRecords.length > 0) {
//           const shuffled = [...newRecords].sort(() => 0.5 - Math.random());
//           setYouMightLike(shuffled.slice(0, 5));
//         }
//       } catch (err) {
//         setError(err.message || "Search failed. Please try again.");
//         setResults([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [query]
//   );

//   // Load initial results
//   useEffect(() => {
//     if (query) {
//       loadResults("");
//     } else {
//       setLoading(false);
//     }
//   }, [query, loadResults]);

//   // ✅ Handle product click - navigate to product detail page
//   const handleProductClick = async (product) => {
//     try {
//       // Show loading state or spinner if needed
//       setLoading(true);

//       // Get detailed product information using the attribution token
//       const productDetails = await getProductDetails(
//         product.id,
//         attributionToken,
//         correctedQuery
//       );

//       // Navigate to product detail page with the product data
//       navigate(`/product/${product.id}`, {
//     state: {
//       product: productDetails,
//       attributionToken: attributionToken,
//       searchQuery: query, // Original query
//       correctedQuery: correctedQuery, // Corrected query from search API
//       fromSearch: true,
//       isInitialCall: true // Mark this as initial call
//     }
//   });
//     } catch (err) {
//       // If there's an error getting details, still navigate but show error in detail page
//       navigate(`/product/${product.id}`, {
//         state: {
//           product: product,
//           fromSearch: true,
//           attributionToken: attributionToken,
//           error: err.message,
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadMore = () => {
//     if (nextPageToken) {
//       loadResults(nextPageToken);
//     }
//   };

//   if (!query) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">No search query provided.</p>
//       </div>
//     );
//   }

//   if (loading && results.length === 0) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Searching...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10">
//       <BackButton />

//       {/* ✅ Show result count and "Did you mean?" */}
//       {!error && (
//         <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
//           {/* Left side - Results count */}
//           <h1 className="text-xl text-gray-800 mb-4">
//             Showing {results.length} of {totalSize} results for "{query}"
//           </h1>

//           {/* Right side - Did you mean? (only show if correction exists) */}
//           {correctedQuery && correctedQuery.trim() !== query.trim() && (
//             <div className="md:self-center">
//               <div className="bg-gradient-to-r from-[#f0f9ff] to-[#f7fcff] border border-[#cdeefc] rounded-xl p-3 shadow-sm transition-all duration-200 hover:shadow-md min-w-[280px]">
//                 <div className="flex items-center space-x-2">
//                   <div className="flex-shrink-0">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-4 w-4 text-[#3a3172]"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm font-medium text-[#2c2452]">
//                       Did you mean:
//                       <button
//                         type="button"
//                         onClick={() =>
//                           (window.location.href = `?q=${encodeURIComponent(
//                             correctedQuery
//                           )}`)
//                         }
//                         className="ml-1 inline-flex items-center px-2 py-1 bg-white text-[#2c2452] text-xs font-semibold rounded-full border border-[#bfeeff] shadow-sm hover:bg-[#f0f9ff] hover:border-blue-400 active:bg-[#e3f5fe] transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-[#3a3172] focus:ring-offset-1 transform hover:scale-105"
//                       >
//                         <span>{correctedQuery}</span>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="h-3 w-3 ml-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M14 5l7 7m0 0l-7 7m7-7H3"
//                           />
//                         </svg>
//                       </button>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {error && <p className="text-red-600 mb-6">{error}</p>}

//       {/* Results Grid */}
//       {results.length === 0 ? (
//         <p className="text-gray-600">No products found.</p>
//       ) : (
//         <>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//             {results.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col cursor-pointer"
//                 onClick={() => handleProductClick(item)} // ✅ Add click handler
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                     {item.name}
//                   </h3>
//                   <p className="text-[#3a3172] font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-3">
//                     {item.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {nextPageToken && (
//             <div className="text-center mt-8">
//               <button
//                 onClick={loadMore}
//                 className="px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800 font-medium"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </>
//       )}

//       {/* You Might Also Like */}
//       {youMightLike.length > 0 && (
//         <div className="mt-12">
//           <h2 className="text-2xl font-bold text-gray-900 mb-6">
//             You Might Also Like
//           </h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6">
//             {youMightLike.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col cursor-pointer"
//                 onClick={() => handleProductClick(item)} // ✅ Add click handler
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/like-${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/like-${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                     {item.name}
//                   </h3>
//                   <p className="text-[#3a3172] font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-2">
//                     {item.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// src/components/SearchResultsPage.jsx
import { useCallback, useEffect, useMemo, useState } from "react";
import { placeholderImage, toPublicStorageUrl } from "../config/imageConfig";
import { useNavigate, useSearchParams } from "react-router-dom";
import { searchProducts, getProductDetails } from "../api/searchApi";
import WishlistToggle from "./WishlistToggle";
import { trackSearchPerformed } from "../services/uiAgentSync";
import { useAuth } from "../context/AuthContext";

const PAGE_SIZE = 10;

/** Sorting runs in the browser, over the results loaded so far. */
const SORTS = [
  { value: "relevance", label: "Relevance" },
  { value: "price-asc", label: "Price: low to high" },
  { value: "price-desc", label: "Price: high to low" },
  { value: "name", label: "Name: A–Z" },
];

const money = (value, currency = "USD") => {
  const n = parseFloat(value);
  if (!Number.isFinite(n)) return "—";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(n);
  } catch (e) {
    return `${currency} ${n.toFixed(2)}`;
  }
};

/** The storefront's product card: photo, name, price. The search API returns
 *  no rating, size or discount, so the card claims none. */
function ResultCard({ item, onOpen }) {
  return (
    <article className="ob-card" onClick={() => onOpen(item)}>
      <div className="ob-shot">
        {item.image ? (
          <img
            src={item.image}
            alt={item.name}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              e.target.src = placeholderImage(item.id, 400, 534);
            }}
          />
        ) : (
          <div className="w-full h-full grid place-items-center ob-ink3 text-[11px]">
            No image
          </div>
        )}

        <div className="ob-favslot" onClick={(e) => e.stopPropagation()}>
          <WishlistToggle product={item} />
        </div>
      </div>

      <div className="ob-card-meta">
        <div className="ob-card-title">{item.name}</div>
        <div className="ob-card-price">{money(item.price, item.currency)}</div>
      </div>
    </article>
  );
}

function ResultsSkeleton({ count = 10 }) {
  return (
    <div className="ob-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <div
            className="ob-skel"
            style={{ aspectRatio: "3 / 4", borderRadius: "var(--ob-r)" }}
          />
          <div className="ob-skel h-3 w-full mt-3" />
          <div className="ob-skel h-3 w-16 mt-2" />
        </div>
      ))}
    </div>
  );
}

function SearchGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-6 h-6"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export default function SearchResultsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get("q");
  const { user, resumeData, resumeLoading } = useAuth(); 

  const [results, setResults] = useState([]);
  const [nextPageToken, setNextPageToken] = useState("");
  const [totalSize, setTotalSize] = useState(0);
  const [correctedQuery, setCorrectedQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");
  const [attributionToken, setAttributionToken] = useState("");
  const [sort, setSort] = useState("relevance");

  // Load results with pagination support
  const loadResults = useCallback(
    async (token = "") => {
      if (!query) return;

      if (token) setLoadingMore(true);
      else setLoading(true);
      setError("");

      try {
        const data = await searchProducts(query, PAGE_SIZE, token);

        const newRecords = data.records.map((p) => ({
          id: p.article_id,
          name: p.prod_name,
          price: parseFloat(p.price).toFixed(2),
          image: toPublicStorageUrl(p.image_uri)?.trim(),
          currency: p.currency,
          description: p.detail_desc || "No description available.",
        }));

        setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
        setNextPageToken(data.next_page_token || "");
        setTotalSize(data.totalSize || 0);
        setCorrectedQuery(data.correctedQuery || "");
        setAttributionToken(data.attributionToken || "");

        // UI → Agent sync: report the manual search (IDs only, first page)
        if (!token) {
          trackSearchPerformed({
            query,
            resultProductIds: newRecords.map((r) => r.id),
            resultCount:
              typeof data.totalSize === "number" && data.totalSize > 0
                ? data.totalSize
                : newRecords.length,
          });
        }
      } catch (err) {
        setError(err.message || "Search failed. Please try again.");
        // A failed "show more" keeps what is already on screen.
        if (!token) setResults([]);
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [query]
  );

  // Load initial results
  // useEffect(() => {
  //   setSort("relevance");
  //   if (query) {
  //     loadResults("");
  //   } else {
  //     setResults([]);
  //     setLoading(false);
  //   }
  // }, [query, loadResults]);

  // Restore search results from Resume API, or fetch fresh results.
  useEffect(() => {
    setSort("relevance");

    if (!query) {
      setResults([]);
      setNextPageToken("");
      setTotalSize(0);
      setCorrectedQuery("");
      setAttributionToken("");
      setLoading(false);
      return;
    }

    // Wait until the Resume API has resolved for a returning customer.
    if (user?.role === "C" && resumeLoading) {
      setLoading(true);
      return;
    }

    const savedSearch = resumeData?.search;

    const isMatchingResumeSearch =
      user?.role === "C" &&
      resumeData?.has_state === true &&
      resumeData?.screen?.view === "search_results" &&
      savedSearch?.query?.trim().toLowerCase() === query.trim().toLowerCase();

    const savedProducts = savedSearch?.payload?.products;

    // Restore saved results only when the backend says they are not stale.
    if (
      isMatchingResumeSearch &&
      resumeData?.freshness?.stale !== true &&
      Array.isArray(savedProducts)
    ) {
      const restoredResults = savedProducts.map((p) => {
        const parsedPrice = Number(p.price);

        return {
          id: p.id || p.article_id,
          name: p.title || p.prod_name || "Untitled product",
          price: Number.isFinite(parsedPrice)
            ? parsedPrice.toFixed(2)
            : p.price,
          image: toPublicStorageUrl(p.image || p.image_uri)?.trim(),
          currency: p.currency || "USD",
          description:
            p.description ||
            p.detail_desc ||
            "No description available.",
        };
      });

      setResults(restoredResults);
      setNextPageToken("");
      setTotalSize(
        savedSearch.result_count ??
        savedSearch.payload.total_results ??
        restoredResults.length
      );
      setCorrectedQuery("");
      setAttributionToken("");
      setError("");
      setLoading(false);
      setLoadingMore(false);

      // Do not report a restored search as a new manual search.
      return;
    }

    // No matching saved search, or saved results are stale.
    loadResults("");
  }, [query, loadResults, user?.role, resumeLoading, resumeData]);

  // Open a result: fetch its detail, then hand it to the product page.
  const handleProductClick = async (product) => {
    try {
      const productDetails = await getProductDetails(
        product.id,
        attributionToken,
        correctedQuery
      );

      navigate(`/product/${product.id}`, {
        state: {
          product: productDetails,
          attributionToken: attributionToken,
          searchQuery: query,
          correctedQuery: correctedQuery,
          fromSearch: true,
          isInitialCall: true,
        },
      });
    } catch (err) {
      navigate(`/product/${product.id}`, {
        state: {
          product: product,
          fromSearch: true,
          attributionToken: attributionToken,
          error: err.message,
        },
      });
    }
  };

  const loadMore = () => {
    if (nextPageToken && !loadingMore) loadResults(nextPageToken);
  };

  const shown = useMemo(() => {
    const num = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };
    const list = [...results];
    switch (sort) {
      case "price-asc":
        return list.sort((a, b) => num(a.price) - num(b.price));
      case "price-desc":
        return list.sort((a, b) => num(b.price) - num(a.price));
      case "name":
        return list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      default:
        return list;
    }
  }, [results, sort]);

  /* ── Nothing searched ── */
  if (!query) {
    return (
      <div className="max-w-[1320px] mx-auto px-4 sm:px-6 py-10 ob-viewin">
        <div className="ob-empty">
          <div className="ob-empty-glyph">
            <SearchGlyph />
          </div>
          <div
            className="ob-display text-[26px]"
            style={{ color: "var(--ob-ink)" }}
          >
            Nothing searched yet
          </div>
          <p className="text-[13px] mt-2 max-w-[360px] mx-auto leading-relaxed">
            Use the search bar above, or simply tell Orbiee what you are after
            in your own words.
          </p>
          <button
            type="button"
            className="ob-btn ob-btn-solid ob-btn-lg mt-6"
            onClick={() => navigate("/")}
          >
            Back to home
          </button>
        </div>
      </div>
    );
  }

  const suggestion =
    correctedQuery && correctedQuery.trim() !== query.trim()
      ? correctedQuery
      : "";

  return (
    <div className="max-w-[1320px] mx-auto px-4 sm:px-6 py-8 ob-viewin">
      {/* ── Header: the query is the headline; the count and any spelling
             suggestion sit under it, sort on the right ── */}
      <header className="mb-7">
        <span className="ob-eyebrow">Search</span>
        <div className="flex items-end justify-between gap-4 flex-wrap mt-1">
          <div className="min-w-0">
            <h1 className="ob-display text-[clamp(1.85rem,4.4vw,2.6rem)] leading-[1.08]">
              &ldquo;{query}&rdquo;
            </h1>
            {!loading && (
              <p className="text-[12.5px] ob-ink2 mt-2">
                {results.length === 0
                  ? "No matches"
                  : `Showing ${results.length}${
                      totalSize > results.length ? ` of ${totalSize}` : ""
                    } ${results.length === 1 ? "piece" : "pieces"}`}
                {suggestion && (
                  <>
                    {" · did you mean "}
                    <button
                      type="button"
                      className="ob-underline font-semibold"
                      style={{ color: "var(--ob-agent)" }}
                      onClick={() =>
                        navigate(`/search?q=${encodeURIComponent(suggestion)}`)
                      }
                    >
                      {suggestion}
                    </button>
                  </>
                )}
              </p>
            )}
          </div>

          {results.length > 1 && (
            <label className="flex items-center gap-2 shrink-0">
              <span className="ob-eyebrow">Sort</span>
              <select
                className="ob-sortselect"
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                aria-label="Sort results"
              >
                {SORTS.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>
      </header>

      {error && (
        <div className="ob-alert mb-6" role="alert">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.85}
            strokeLinecap="round"
            className="w-[15px] h-[15px] shrink-0 mt-[1px]"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5M12 16.2v.1" />
          </svg>
          <span>{error}</span>
        </div>
      )}

      {/* ── Results ── */}
      {loading ? (
        <ResultsSkeleton />
      ) : results.length === 0 ? (
        <div className="ob-empty">
          <div className="ob-empty-glyph">
            <SearchGlyph />
          </div>
          <div
            className="ob-display text-[26px]"
            style={{ color: "var(--ob-ink)" }}
          >
            Nothing matched that
          </div>
          <p className="text-[13px] mt-2 max-w-[380px] mx-auto leading-relaxed">
            We found nothing for &ldquo;{query}&rdquo;. Try fewer words, or tell
            Orbiee the occasion and let it choose.
          </p>
          <button
            type="button"
            className="ob-btn ob-btn-solid ob-btn-lg mt-6"
            onClick={() => navigate("/")}
          >
            Back to home
          </button>
        </div>
      ) : (
        <>
          <div className="ob-grid ob-stagger">
            {shown.map((item) => (
              <ResultCard key={item.id} item={item} onOpen={handleProductClick} />
            ))}
          </div>

          {nextPageToken && (
            <div className="flex justify-center mt-10">
              <button
                type="button"
                className="ob-btn ob-btn-quiet ob-btn-lg"
                onClick={loadMore}
                disabled={loadingMore}
              >
                {loadingMore ? (
                  <>
                    <span className="ob-spinner" aria-hidden="true" />
                    Loading
                  </>
                ) : (
                  "Show more"
                )}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
